var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "h-max relative"
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("男：" + _vm._s(_vm.source.nan || 0) + " 女：" + _vm._s(_vm.source.nv || 0))]), _c('div', {
    staticClass: "h-max",
    attrs: {
      "id": "patientDivision"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };